<template>
    <section class="content">
      <div class="box box-info">
      
      <div class="p-toolbar p-component mb-4">
        <crmProductDetailsDialog ref="openDialog"/>
        </div>
          <a href="#"  @click.prevent="exportCSV()" v-if="this.crmProductLists.length > 0">
            <img src="../../../../static/img/excel.png" style="margin-top: 1em;width: 4%;float: right;"/>
         </a>
      <DataTable ref="po"
      :value="crmProductLists"
      :paginator="true"
      :rows="8" :filters="filters"
      class="p-datatable-responsive p-datatable-customers"
    >
      <Column header="S.n">
        <template #body="slotProps">
        {{slotProps.index+1}}
        </template>
      </Column>
      <Column :sortable="true"   header="Name" field="name" filterMatchMode="contains" >
         <template #filter>
           <InputText type="text" class="p-column-filter" v-model="filters['name']" />
         </template>
      </Column>
      <Column :sortable="true"
        header="Code"
        field="itemCode"
        filterMatchMode="contains"
      >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['itemCode']" />
        </template>
      </Column>

    <Column :sortable="true" header="Unit" field="unit" filterMatchMode="contains" >
     <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['unit']" />
        </template>
      </Column>

      <Column :sortable="true" header="M.P.Rate" field="marketPurchasePrice"
       filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['marketPurchasePrice']" />
        </template>
      </Column>

       <Column :sortable="true" header="M.S.Rate" field="marketSellingPrice" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['marketSellingPrice']" />
        </template>
      </Column>

      <Column :sortable="true" header="Sales rate" field="sellingPrice" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['sellingPrice']" />
        </template>
      </Column>
      <Column :sortable="true" header="Comission Rate" field="commissionRate" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['commissionRate']" />
        </template>
      </Column>

      <Column :sortable="true" header="Discount Rate" field="discountRate" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['discountRate']" />
        </template>
      </Column>

      <Column :sortable="true" header="Sales Started Date" field="startDate" filterMatchMode="contains">
        <template #body="slotProps">
          {{ formatDate(slotProps.data.startDate) }}
        </template>
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['startDate']" />
        </template>
      </Column>

    <Column header="Action" headerStyle="width: 11em">
        <template #body="slotProps">


            <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editCrmProduct(slotProps.data)" />

            <Button icon="pi pi-trash" class="p-button-danger p-button-sm"   @click="openDialog(slotProps.data.id)"/>

        </template>
      </Column>


      </DataTable>
     </div>
     <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteCrmProduct"/>

   </section>

</template>
<script>
import crmProductDetailsDialog from '../crmDialog/crmProductDetailsDialog.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'customer',
  data() {
    return {
      displayBasic: false,
      dialogShow: false,
      columnList: '',
      filters: {}
    }
  },
  computed: {
    crmProductLists () {
      return this.$store.state.crm.crmProductLists
    }
  },
  mounted() {
    this.crmProductList()
    this.columnNames()
  },
  methods: {
    async deleteCrmProduct(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        productId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteCrmProduct', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.closeDialog()
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
        this.closeDialog()
      }
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString()
    },
    editCrmProduct(data) {
      this.$refs.openDialog.editCrmProduct(data)
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Customer List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'customerList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async crmProductList() {
      await this.$store.dispatch('loadCrmProductList')
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    cancel(data) {
      this.dialogShow = false
    }
  },
  components: {
    Column,
    DataTable,
    Dialog,
    InputText,
    crmProductDetailsDialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// crmProductDetails.vue?d456f234